import { gtm, locationHash } from '@shared';
import { basicActionCreator } from '@utils';

import { UPLOAD_FILE_RESPONSE, uploadFileResponse } from '../common/actions';
import { advancementUploadModuleNamespace as moduleNamespace } from '../common/constants';
import { moduleName, tabNames } from '../constants';

export {
  SET_UNIT,
  setUnit,
  SET_RECENT_UNITS,
  setRecentUnits,
  setRecentUnit,
  removeRecentUnit,
} from '@shared';

export const ROUTE_COUNCIL_UNITS = `${moduleName}/ROUTE_COUNCIL_UNITS`;
export const goToCouncilUnitsPage = () => ({ type: ROUTE_COUNCIL_UNITS });

export const SET_ACTIVE_TAB = `${moduleName}/SET_ACTIVE_TAB`;
export const setActiveTab = tabName => dispatch => {
  locationHash.set(tabName);
  dispatch({
    type: SET_ACTIVE_TAB,
    payload: tabName,
  });
};

export const goToRecentUnitsTabPage = () => dispatch => {
  dispatch(goToCouncilUnitsPage());
  dispatch(setActiveTab(tabNames.RECENT_UNITS));
};

export const UNITS_SEARCH_REQUEST = `${moduleName}/UNITS_SEARCH_REQUEST`;
export const UNITS_SEARCH_RESPONSE = `${moduleName}/UNITS_SEARCH_RESPONSE`;
export const UNITS_SEARCH_ERROR = `${moduleName}/UNITS_SEARCH_ERROR`;
export const unitsSearchRequest = filter => ({
  type: UNITS_SEARCH_REQUEST,
  payload: filter,
  gtm: {
    category: gtm.categories.COUNCIL_UNITS,
  },
});
export const unitsSearchResponse = units => ({
  type: UNITS_SEARCH_RESPONSE,
  payload: units,
});
export const unitsSearchError = err => ({
  type: UNITS_SEARCH_ERROR,
  payload: err,
});

export const UNITS_SEARCH_REDIRECT_REQUEST = `${moduleName}/UNITS_SEARCH_REDIRECT_REQUEST`;
export const unitsSearchRedirectRequest = ({ orgGuid, unitTypeId }) => ({
  type: UNITS_SEARCH_REDIRECT_REQUEST,
  payload: { orgGuid, unitTypeId: +unitTypeId },
  gtm: {
    category: gtm.categories.COUNCIL_UNITS,
  },
});

export const SET_SEARCH = `${moduleName}/SET_SEARCH`;
export const setSearch = search => ({ type: SET_SEARCH, payload: search });
export const SET_SORTER = `${moduleName}/SET_SORTER`;
export const setSorter = ({ columnKey, order }) => ({
  type: SET_SORTER,
  payload: { columnKey, order },
});
export const SET_RECENT_UNITS_SORTER = `${moduleName}/SET_RECENT_UNITS_SORTER`;
export const setRecentUnitsSorter = ({ columnKey, order }) => ({
  type: SET_RECENT_UNITS_SORTER,
  payload: { columnKey, order },
});
export const SET_RECENT_UNITS_SEARCH = `${moduleName}/SET_RECENT_UNITS_SEARCH`;
export const setRecentUnitsSearch = search => ({
  type: SET_RECENT_UNITS_SEARCH,
  payload: search,
});

export const LOAD_DISTRICTS_REQUEST = `${moduleName}/LOAD_DISTRICTS_REQUEST`;
export const LOAD_DISTRICTS_RESPONSE = `${moduleName}/LOAD_DISTRICTS_RESPONSE`;
export const LOAD_DISTRICTS_ERROR = `${moduleName}/LOAD_DISTRICTS_ERROR`;
export const loadDistrictsRequest = () => ({
  type: LOAD_DISTRICTS_REQUEST,
  gtm: {
    category: gtm.categories.COUNCIL_UNITS,
  },
});
export const loadDistrictsResponse = districts => ({
  type: LOAD_DISTRICTS_RESPONSE,
  payload: districts,
});
export const loadDistrictsError = err => ({
  type: LOAD_DISTRICTS_ERROR,
  payload: err,
});

// EXTERNAL MBR MODAL
export const OPEN_MBR_MODAL_VISIBLE = `${moduleName}/OPEN_MBR_MODAL_VISIBLE`;
export const openMBRModalVisible = () =>
  basicActionCreator(OPEN_MBR_MODAL_VISIBLE);

export const CLOSE_MBR_MODAL_VISIBLE = `${moduleName}/CLOSE_MBR_MODAL_VISIBLE`;
export const closeMBRModalVisible = () =>
  basicActionCreator(CLOSE_MBR_MODAL_VISIBLE);

export { UPLOAD_FILE_RESPONSE, uploadFileResponse };

export const OPEN_UPLOAD_MODAL = `${moduleNamespace}/OPEN_UPLOAD_MODAL`;
export const CLOSE_UPLOAD_MODAL = `${moduleNamespace}/CLOSE_UPLOAD_MODAL`;
export const openUploadModal = () => ({ type: OPEN_UPLOAD_MODAL });
export const closeUploadModal = () => ({ type: CLOSE_UPLOAD_MODAL });

export const UPLOAD_FILE_REQUEST = `${moduleNamespace}/UPLOAD_FILE_REQUEST`;
export const UPLOAD_FILE_ERROR = `${moduleNamespace}/UPLOAD_FILE_ERROR`;
export const UPLOAD_FILE_CANCEL = `${moduleNamespace}/UPLOAD_FILE_CANCEL`;
export const UPLOAD_FILE_PROGRESS = `${moduleNamespace}/UPLOAD_FILE_PROGRESS`;
export const uploadFileRequest = file => ({
  type: UPLOAD_FILE_REQUEST,
  payload: file,
  gtm: {
    category: gtm.categories.ADVANCEMENTS,
  },
});
export const uploadFileError = err => ({
  type: UPLOAD_FILE_ERROR,
  payload: err,
});
export const uploadFileCancel = () => ({ type: UPLOAD_FILE_CANCEL });
export const uploadFileProgress = progress => ({
  type: UPLOAD_FILE_PROGRESS,
  payload: progress,
});

export const CANCEL_FILE_REQUEST = `${moduleNamespace}/CANCEL_FILE_REQUEST`;
export const CANCEL_FILE_RESPONSE = `${moduleNamespace}/CANCEL_FILE_RESPONSE`;
export const CANCEL_FILE_ERROR = `${moduleNamespace}/CANCEL_FILE_ERROR`;
export const cancelFileRequest = ({ id, successMsg }) => ({
  type: CANCEL_FILE_REQUEST,
  payload: {
    id,
    successMsg,
  },
  gtm: {
    category: gtm.categories.ADVANCEMENTS,
  },
});
export const cancelFileResponse = id => ({
  type: CANCEL_FILE_RESPONSE,
  payload: id,
});
export const cancelFileError = id => ({
  type: CANCEL_FILE_ERROR,
  payload: id,
});

export const OPEN_ERRORS_MODAL = `${moduleNamespace}/OPEN_ERRORS_MODAL`;
export const CLOSE_ERRORS_MODAL = `${moduleNamespace}/CLOSE_ERRORS_MODAL`;
export const openErrorsModal = () => ({ type: OPEN_ERRORS_MODAL });
export const closeErrorsModal = () => ({ type: CLOSE_ERRORS_MODAL });
